
















import {Component} from '@/shared/component';
import {AbstractSearchVue} from '@/components/Abstract/AbstractSearchVue';

import InputSearchEntity from '@/components/Input/SearchEntity.vue';
import CrudLongueursAchatFilter from '@/components/Crud/LongueursAchat/Filter.vue';
import CrudLongueursAchatList from '@/components/Crud/LongueursAchat/List.vue';

@Component({
	components: {
		CrudLongueursAchatFilter,
		CrudLongueursAchatList,
		InputSearchEntity,
	}
})
export default class CrudLongueursAchatSearch extends AbstractSearchVue {
	private filterComponent = CrudLongueursAchatFilter;
	private listComponent = CrudLongueursAchatList;
}
